import { render, staticRenderFns } from "./TransactionInvoiceTable.vue?vue&type=template&id=46dc82be&scoped=true&"
import script from "./TransactionInvoiceTable.vue?vue&type=script&lang=js&"
export * from "./TransactionInvoiceTable.vue?vue&type=script&lang=js&"
import style0 from "./TransactionInvoiceTable.vue?vue&type=style&index=0&id=46dc82be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dc82be",
  null
  
)

export default component.exports